'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type CctvProps = IconProps<keyof typeof animations>;
const animations = {
  default: {
    group: {
      initial: {
        rotate: 0,
        y: 0,
        x: 0,
        scale: 1
      },
      animate: {
        rotate: [0, -20, -20, 15, 15, 0],
        y: [0, -0.5, -0.5, 0, 0, 0],
        x: [0, 0, 0, 0.5, 0.5, 0],
        scale: [1, 1.08, 1, 1.08, 1],
        transition: {
          duration: 1.8,
          ease: 'easeInOut'
        }
      }
    },
    path1: {},
    path2: {},
    path3: {
      initial: {
        opacity: 1
      },
      animate: {
        opacity: [1, 0, 1, 0, 1, 0, 1],
        transition: {
          duration: 1.8,
          ease: 'easeInOut'
        }
      }
    },
    path4: {},
    path5: {}
  } satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(22);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  let t3;
  let t4;
  if ($[4] !== controls) {
    t2 = <motion.path d="M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97" variants={variants.path1} initial="initial" animate={controls} />;
    t3 = <motion.path d="M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z" variants={variants.path2} initial="initial" animate={controls} />;
    t4 = <motion.path d="M7 9h.01" variants={variants.path3} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== controls || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <motion.g variants={variants.group} initial="initial" animate={controls}>{t2}{t3}{t4}</motion.g>;
    $[8] = controls;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  let t7;
  if ($[13] !== controls) {
    t6 = <motion.path d="M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" variants={variants.path4} initial="initial" animate={controls} />;
    t7 = <motion.path d="M2 21v-4" variants={variants.path5} initial="initial" animate={controls} />;
    $[13] = controls;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[16] !== props || $[17] !== size || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>{t5}{t6}{t7}</motion.svg>;
    $[16] = props;
    $[17] = size;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function Cctv(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, Cctv, Cctv as CctvIcon, type CctvProps, type CctvProps as CctvIconProps };